import * as React from 'react';
import * as styles from './hero.module.scss';

export default ({ videoPath }: { videoPath: string }) => (
  <video className={styles.video} autoPlay muted loop>
    <source src={videoPath} type="video/mp4" />
    <source src={videoPath} type="video/ogg" />
  </video>
);
